import { LogIn } from '../interfaces/login.interface';
import { BaseEmailDto } from './base-email.dto';

class LoginCredentialsDto extends BaseEmailDto implements LogIn {
  password: string;

  constructor({ email, password }: LoginCredentialsDto) {
    super({ email });

    this.password = password;
  }
}

export { LoginCredentialsDto };
